import { Navigate, RouteObject, RouterProvider, createBrowserRouter, useSearchParams } from "react-router-dom";
import { AppLayout } from "./layout/AppLayout";
import { HomePage } from "./pages/Home";
import { CadastrarPage } from "./pages/Cadastrar";
import { ComprarTitulosPage } from "./pages/ComprarTitulos";
import { ResultadosPage } from "./pages/Resultados";
import { AutenticacaoPage } from "./pages/AutenticacaoPage";
import { useAuth } from "./contexts/AuthProvider";
import { FinalizarCompraPage } from "./pages/FinalizarCompra";
import { useCarrinho } from "./contexts/CarrinhoProvider";
import { UltimasCompras } from "./pages/UltimasCompras";
import { ExtratoCreditos } from "./pages/ExtratoCreditos";
import { InserirCreditosPage } from "./pages/InserirCreditos";
import { QrCodePage } from "./components/QrCodePage";
import { MeuPerfilPage } from "./pages/MeuPerfil";
import { EditarPerfilPage } from "./pages/EditarPerfil";
import AlterarSenhaPage from "./pages/AlterarSenha";
import EsqueciMinhaSenhaPage from "./pages/EsqueciMinhaSenha";
import { CompraRapidaPage } from "./pages/CompraRapida";
import { CompraRapidaGiroPage } from "./pages/CompraRapidaGiro";
import { EtapaPagamentoQrCode } from "./pages/CompraRapida/EtapaPagamentoQrCode";
import { DetalhesCompraPage } from "./pages/DetalhesCompra";
import { PrimeiroAcessoPage } from "./pages/PrimeiroAcesso";
import { PoliticaPrivacidadePage } from "./pages/PoliticaPrivacidadePage";
import { PoliticaPrivacidadeAplicativoPage } from "./pages/PoliticaPrivacidadeAplicativo";
import { AutenticarPorCodigo } from "./pages/AutenticarPorCodigo";
import { ConferirResultadoPage } from "./pages/ConferirResultadoPage";
import { FinalizarCompraGiroPage } from "./pages/FinalizarCompraGiro";
import { QrCodeGiroPage } from "./pages/FinalizarCompraGiro/QrCodeGiroPage";

function FinalizarCompraAppRouter() {
    const [searchParams] = useSearchParams();
    if (searchParams.get("tipo") === "giro") {
        return <FinalizarCompraGiroPage />;
    }
    return <FinalizarCompraPage />;
}

export function Routes() {
    const { isAuthorized, loading } = useAuth();
    const { qtdCarrinho } = useCarrinho();

    //TODO: Corrigir isso!!!
    if (loading) {
        return;
    }

    let children: RouteObject[] = [
        {
            path: '/',
            element: <HomePage />
        },
        {
            path: '/compra/titulos',
            element: <ComprarTitulosPage />
        },
        {
            path: '/compra/detalhes/:idCompra',
            element: <DetalhesCompraPage />
        },
        {
            path: '/compra/rapida/qrcode',
            element: <EtapaPagamentoQrCode />
        },
        {
            path: '/compra/rapida/giro/qrcode',
            element: <EtapaPagamentoQrCode />
        },
        {
            path: '/compra/rapida/giro',
            element: <CompraRapidaGiroPage />
        },
        {
            path: '/compra/rapida/',
            element: <CompraRapidaPage />
        },
        {
            path: '/titulosdisponiveis',
            element: <ComprarTitulosPage />
        },
        {
            path: '/politicaprivacidade',
            element: <PoliticaPrivacidadePage />
        },
        {
            path: '/resultados',
            element: <ResultadosPage />
        },
        {
            path: '/conferir-resultado',
            element: <ConferirResultadoPage />
        },
        {
            path: '/compra/extrato-compras',
            element: <UltimasCompras />
        },
        {
            path: '/compra/extrato-creditos',
            element: <ExtratoCreditos />
        },
        {
            path: '/compra/finalizar/qrcode',
            element: <QrCodePage />
        },
        {
            path: '/compra/finalizar/giro/qrcode',
            element: <QrCodeGiroPage />
        },
        {
            path: '/EsqueciMinhaSenha',
            element: <EsqueciMinhaSenhaPage />
        },
        {
            path: '/RedefinirSenha',
            element: <EsqueciMinhaSenhaPage />
        },
        {
            path: '/PrimeiroAcesso',
            element: <PrimeiroAcessoPage />
        },
        {
            path: '/AutenticarPorCodigo',
            element: <AutenticarPorCodigo />
        }
    ];

    if (!isAuthorized) {
        children = children.concat([
            {
                path: '/Cadastrar',
                element: <CadastrarPage />
            },
            {
                path: '/Acessar',
                element: <AutenticacaoPage />
            }
        ])
    }

    if (isAuthorized) {
        children = children.concat([
            {
                path: '/compra/creditos',
                element: <InserirCreditosPage />
            },
            {
                path: '/perfil',
                element: <MeuPerfilPage />
            },
            {
                path: '/perfil/editar',
                element: <EditarPerfilPage />
            },
            {
                path: '/alterarsenha',
                element: <AlterarSenhaPage />
            }
        ]);

        if (qtdCarrinho > 0) {
            children = children.concat([
                {
                    path: '/compra/finalizar',
                    element: <FinalizarCompraPage />
                }
            ]);
        }

        children = children.concat([
            {
                path: '/compra/finalizar/giro',
                element: <FinalizarCompraGiroPage />
            }
        ]);
    }

    children = children.concat(
        [
            {
                path: '*',
                element: <Navigate to="/" replace />
            }
        ]
    )

    const routes = [
        {
            path: "/",
            element: <AppLayout />,
            children: children
        },
        {
            path: '/politica-privacidade',
            element: <PoliticaPrivacidadeAplicativoPage />
        },
        {
            path: '/finalizarcompraapp',
            element: <FinalizarCompraAppRouter />
        },
        {
            path: '/finalizarcompragiroapp',
            element: <FinalizarCompraGiroPage />
        }
    ];

    const router = createBrowserRouter(routes);

    return <RouterProvider router={router} />
}